import { render, staticRenderFns } from "./changeUntied.vue?vue&type=template&id=5331b33f&scoped=true&"
import script from "./changeUntied.vue?vue&type=script&lang=js&"
export * from "./changeUntied.vue?vue&type=script&lang=js&"
import style0 from "./changeUntied.vue?vue&type=style&index=0&id=5331b33f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331b33f",
  null
  
)

component.options.__file = "changeUntied.vue"
export default component.exports